/**
 * @fileoverview Contiene los servicios de consumo a la API para Modelo de Vehiculos
 *
 * @version 1.0
 *
 * @author José Antonio Rodríguez Barceló
 *
 * @copyright Shuttle Express México
 *
 * Historial
 * ---------
 * La primera versión fue escrita por José Antonio Rodríguez Barceló
 */

import api from '@/services/api'
const END_POINT = 'vehiculos/modelos'

export default {
  /**
   * @name getModelsVehicle
   * @description Obtiene un listado de documentos segun parametros
   *
   * @param {*} params campo1 -> Parametros para poblar el select
   * @returns {array} devuelve un arreglo de json con los documentos
   */
  getModelsVehicle(params) {
    if (params != null) {
      return api.get(END_POINT + params)
    }

    return api.get(END_POINT)
  },

  /**
   * @name posttModelsVehicle
   * @description Se crea el Modelo de Vehiculo
   *
   * @param {*} jwt JSON Web Token válido
   * @param {*} body Input del formulario -> Propiedades para crear el Modelo de Vehiculo
   */
  postModelVehicle(jwt, body) {
    return api.post(END_POINT, body)
  },

  /**
   * @name patchModelVehicle
   * @description Se actualiza el Modelo de Vehiculo
   *
   * @param {*} jwt JSON Web Token válido
   * @param {*} body Input del formulario -> Propiedades para actualizar el Modelo de Vehiculo
   * @param {*} id this.editedItem._id -> id del Modelo de Vehiculo que se va a actualizar
   */
  patchModelVehicle(jwt, body, id) {
    return api.patch(END_POINT + '/' + id, body)
  },

  /**
   * @name deleteModelVehicle
   * @description Elimina un documento por su id
   *
   * @param {*} id _id -> id del documento que se va a eliminar
   * @returns {json} json con el resultado de eliminar el documento
   */
  deleteModelVehicle(id) {
    return api.delete(END_POINT + '/' + id)
  },
}
